import PropTypes from 'prop-types';
import { Button } from '@etg/wings';
import isFunction from 'lodash/isFunction';
import { useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';

const buttonsWrapperStyles = css`
  display: flex;
  flex: 1 0 100%;
  gap: 16px;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: 20px;

  @media ${mediaQueries.large.up} {
    margin-bottom: 30px;
  }
`;

const buttonStyles = css`
  flex: 1;

  @media ${mediaQueries.medium.up} {
    max-width: 158px;
  }

  @media ${mediaQueries.large.up} {
    max-width: 212px;
  }
`;

const FiltersButtons = ({ onDone, onClear }) => {
  const { t } = useTranslation();

  const handleDone = () => {
    if (isFunction(onDone)) {
      onDone();
    }
  };

  const handleClear = () => {
    if (isFunction(onClear)) {
      onClear();
    }
  };

  return (
    <div className={buttonsWrapperStyles}>
      <Button
        className={buttonStyles}
        data-testid="filtersForm-resetFilters-button"
        onClick={handleClear}
      >
        {t('Result.SearchFilters.ClearAllFilters.Button')}
      </Button>
      <Button
        className={buttonStyles}
        data-testid="filtersForm-applyFilters-button"
        onClick={handleDone}
        variant="primary"
      >
        {t('Result.SearchFilters.Done.Button')}
      </Button>
    </div>
  );
};

FiltersButtons.propTypes = {
  onClear: PropTypes.func,
  onDone: PropTypes.func,
};

export default FiltersButtons;
